var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }
import styled, { css } from 'styled-components';
var colour = function colour(color, theme) {
  var colors = {
    error: theme.palette.error.main,
    inherit: 'inherit',
    primary: theme.palette.primary.main,
    secondary: theme.palette.secondary.main,
    textPrimary: theme.palette.text.primary,
    textSecondary: theme.palette.text.secondary
  };
  if (colors[color]) {
    return colors[color];
  }
  return colors.inherit;
};
export var StyledLink = styled.a(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var color = _ref.color,
    underline = _ref.underline,
    theme = _ref.theme;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-weight: 500;\n    text-decoration: none;\n    ", "\n    ", "\n    ", "\n  "])), theme.typography.fontFamily, underline === 'hover' && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      &:hover {\n        text-decoration: underline;\n      }\n    "]))), underline === 'always' && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      text-decoration: underline;\n    "]))), color && css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      color: ", ";\n    "])), colour(color, theme)));
});